module.exports = __webpack_public_path__ + "img/IMG-20200519-WA0013.e9c329be.jpg";